export default function EventTypeSelect (props) {
  const {
    eventTypes = [],
    value,
    onChange,
    disabled = false
  } = props

  return (
    <div className='form-group'>
      <label>{I18n.t('activerecord.models.calendar/event_type.one')}</label>
      <select
        className='form-control'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {eventTypes.map((eventType) => (
          <option key={eventType.id} value={eventType.id}>
            {eventType.name}
          </option>
        ))}
      </select>
    </div>
  )
}
